import request from '@/utils/request'

/**
 * @description: 分页查询教室巡视列表
 * @param {*} params
 * @return {*}
 */
const classroomInspectionSearchByPage = (params) => {
  return request({
    url: '/admin/classroom/inspection/searchByPage',
    method: 'post',
    data: params
  })
}

/**
 * @description: 单教室巡视详情
 * @param {*} params
 * @return {*}
 */
const classroomInspectionDetail = (params) => {
  return request({
    url: '/admin/classroom/inspection/detail',
    method: 'post',
    params
  })
}

/**
 * @description: 查询配置
 * @param {*} params
 * @return {*}
 */
const clientSettingGet = (params) => {
  return request({
    url: '/admin/client/setting/get',
    method: 'get',
    params
  })
}

/**
 * @description: 编辑配置
 * @param {*} params
 * @return {*}
 */
const clientSettingEdit = (params) => {
  return request({
    url: '/admin/client/setting/edit',
    method: 'post',
    data: params
  })
}

/**
 * @description: 设置教室降噪等级
 * @param {*} params
 * @return {*}
 */
const settingSetClassroomNoiseAns = (params) => {
  return request({
    url: '/admin/client/setting/setClassroomNoiseAns',
    method: 'post',
    params
  })
}

/**
 * @description: 查询正在巡视用户
 * @param {*} classroomCode-教室编号 liveId
 * @return {*} 正在巡视用户列表
 */
const inspectingUsers = (params) => {
  return request({
    url: '/admin/classroom/inspection/inspectingUsers',
    method: 'get',
    params
  })
}

/**
 * @description: 新增/修改巡视记录
 * @param {*} classroomCode-教室编号 liveId type-1开始巡视，2结束巡视
 * @return {*} null
 */
const createUpdateInspectRecord = (params) => {
  return request({
    url: '/admin/classroom/inspection/createOrUpdateRecord',
    method: 'post',
    data: params
  })
}

/**
 * @description: 教室巡视备注 & 巡视记录列表
 * @param {*} classroomCode-教室编号 pageNum第几页,下标从1开始 pageSize每页展示条目数
 * @return {*}
 */
const searchInspectRecordByPage = (params) => {
  return request({
    url: '/admin/classroom/inspection/searchRecordByPage',
    method: 'post',
    data: params
  })
}
/**
 * @description: 巡视备注
 * @param {*} classroomCode-教室编号
 * @return {*}
 */
const inspectExtendInfo = (params) => {
  return request({
    url: '/admin/classroom/inspection/extendInfo',
    method: 'get',
    params
  })
}
/**
 * @description: 编辑备注
 * @param {*} classroomCode-教室编号 notes巡视备注
 * @return {*}
 */
const inspectionEditNotes = (params) => {
  return request({
    url: '/admin/classroom/inspection/editNotes',
    method: 'post',
    data: params
  })
}
/**
 * @description: 巡视回放列表
 * @param {*} classroomCode-教室编号 keywords关键字支持直播名称/主讲姓名 pageNum第几页,下标从1开始 pageSize每页展示条目数
 * @return {*}
 */
const inspectSearchVideoByPage = (params) => {
  return request({
    url: '/admin/classroom/inspection/searchVideoByPage',
    method: 'post',
    data: params
  })
}
const getVideoUrl = (params) => {
  return request({
    baseURL: '//newbase.zhihuishu.com',
    url: '/video/initVideoNew',
    method: 'get',
    params
  })
}

/**
 * @description: 开启“RTMP直播”相关
 * @param {*} params
 * @return {*}
 */
const clientSettingPushOrStopCdn = (params) => {
  return request({
    url: '/admin/client/setting/pushOrStopCdn',
    method: 'post',
    params
  })
}

/**
 * @description: 根据教室code查询学校信息
 * @param {*} params
 * @return {*}
 */
const classroomInspectionGetSchoolInfo = (params) => {
  return request({
    url: '/admin/classroom/inspection/getSchoolInfo',
    method: 'get',
    params
  })
}

/**
 * @description: 获取课堂观摩设置
 * @param {*} params
 * @return {*}
 */
const livesettingCdnViewSettingGet = (params) => {
  return request({
    url: '/admin/livesetting/cdnViewSetting/get',
    method: 'get',
    params
  })
}

/**
 * @description: 课堂观摩设置
 * @param {*} params
 * @return {*}
 */
const livesettingCdnViewSetting = (params) => {
  return request({
    url: '/admin/livesetting/cdnViewSetting',
    method: 'post',
    params
  })
}

/**
 * @description: 继续/暂停直播
 * @param {*} params
 * @return {*}
 */
const livesettingContinueOrStopLive = (params) => {
  return request({
    url: '/admin/livesetting/continueOrStopLive',
    method: 'post',
    params
  })
}

/**
 * @description: 获取cdn拉流地址
 * @param {*} params
 * @return {*}
 */
const livesettingCdnPullUrlGet = (params) => {
  return request({
    url: '/admin/livesetting/cdnPullUrl/get',
    method: 'get',
    params
  })
}

/**
 * @description: 已结束的直播更改为未开始状态
 * @param {*} params
 * @return {*}
 */
const cloudCasterResetLive = (params) => {
  return request({
    url: '/admin/cloud-caster/resetLive',
    method: 'POST',
    params
  })
}

/**
 * @description: 修改直播名称
 * @param {*} params
 * @return {*}
 */
const updateLiveInfo = (params) => {
  return request({
    url: '/admin/cloud-caster/updateLiveInfo',
    method: 'post',
    params
  })
}

export default {
  classroomInspectionSearchByPage,
  classroomInspectionDetail,
  clientSettingGet,
  clientSettingEdit,
  settingSetClassroomNoiseAns,
  inspectingUsers,
  createUpdateInspectRecord,
  searchInspectRecordByPage,
  inspectExtendInfo,
  inspectionEditNotes,
  inspectSearchVideoByPage,
  getVideoUrl,
  clientSettingPushOrStopCdn,
  classroomInspectionGetSchoolInfo,
  livesettingCdnViewSettingGet,
  livesettingCdnViewSetting,
  livesettingContinueOrStopLive,
  livesettingCdnPullUrlGet,
  cloudCasterResetLive,
  updateLiveInfo
}
